import { render, staticRenderFns } from "./form-senha.vue?vue&type=template&id=6a3b5314"
import script from "./form-senha.vue?vue&type=script&lang=js"
export * from "./form-senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports